import { send } from './ipc';

export default {
  getNetworkInterface: () => send('getNetworkInterface'),
  getScreenInfo: () => send('getScreenInfo'),
  setScreenOn: () => send('setScreenOn'),
  setScreenOff: () => send('setScreenOff'),

  selfUpdate: () => send('selfUpdate'),

  getDisplayInfo: () => send('getDisplayInfo'),
  startDisplay: () => send('startDisplay'),
  restartDisplay: () => send('restartDisplay'),
  stopDisplay: () => send('stopDisplay'),
  refreshDisplay: () => send('refreshDisplay'),
  setOpenboxStarted: () => send('setOpenboxStarted'),
};
